import React from "react";
import "./App.scss";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./containers/home/Home";
import Header from "./containers/header/Header";
import Footer from "./containers/footer/Footer";
import ContactPage from "./containers/contact-page/ContactPage";
import Services from "./containers/services/Services";
import About from "./containers/about/About";

import ScrollIntoView from "./containers/ScrollToTop";

function App() {
  return (
    <div className="key_realty">
      <BrowserRouter>
        <ScrollIntoView>
          {console.log("Hello")}
          <Header />

          <Routes>
            <Route path="/contact-us" element={<ContactPage />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/" element={<Home />} />
          </Routes>

          <Footer />
        </ScrollIntoView>
      </BrowserRouter>
    </div>
  );
}

export default App;
